export const NewTabHint: React.FC<{
  text?: string;
}> = ({ text = 'Öffnet ein neues Browser-Tab' }) => {
  return <span className="sr-only">{text}</span>;
};
